import { render, staticRenderFns } from "./PriceCategorySalesDatesEdit.vue?vue&type=template&id=efa7e3e2"
import script from "./PriceCategorySalesDatesEdit.vue?vue&type=script&lang=ts"
export * from "./PriceCategorySalesDatesEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efa7e3e2')) {
      api.createRecord('efa7e3e2', component.options)
    } else {
      api.reload('efa7e3e2', component.options)
    }
    module.hot.accept("./PriceCategorySalesDatesEdit.vue?vue&type=template&id=efa7e3e2", function () {
      api.rerender('efa7e3e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/PriceCategorySalesDatesEdit.vue"
export default component.exports